import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { PhoneContactEdit } from "@/Patient/Components/Profile/ContactComponents/PhoneContactEdit";

interface IPhonesEditProps {
    phones: PhoneNumber[];
    onAdd: () => void;
    onRemove: (phoneNumber: PhoneNumber) => void;
    onNumberChange?: (value: string, index: number) => void;
    onTypeSelect: (value: string, index: number) => void;
    onCountrySelect: (value: string, index: number) => void;
    onExtChange: (value: string, index: number) => void;
    onNoteChange: (value: string, index: number) => void;
    onDefaultNotificationChange: (isChecked: boolean, index: number) => void;
    onIsPreferredChange: (isChecked: boolean, index: number) => void;
}

function PhonesEdit(props: IPhonesEditProps): JSX.Element {
    const { getText } = useTranslation();

    return (
        <>
            <div><span>{getText("PhoneLabel")}</span></div>
            <div>
                <table>{props.phones
                    .sortByPropertyDesc(p => p.IsPreferred)
                    .map((phone, idx) => (
                        <div key={`phone_${phone.ContactPoint_id}`} className="flex-container">
                            <table>
                                <PhoneContactEdit
                                    key={`phoneContact_${phone.renderId}`}
                                    phoneNumber={phone}
                                    onPhoneTypeSelect={(value: string) => props.onTypeSelect(value, idx)}
                                    onRemove={() => props.onRemove(phone)}
                                    onCountrySelect={value => props.onCountrySelect(value, idx)}
                                    onPhoneNumberChange={value => props.onNumberChange(value, idx)}
                                    onPhoneExtChange={value => props.onExtChange(value, idx)}
                                    onNoteChange={value => props.onNoteChange(value, idx)}
                                    onIsPreferredChange={value => props.onIsPreferredChange(value, idx)}
                                    onDefaultNotificationChange={checked => props.onDefaultNotificationChange(checked, idx)}
                                />
                                {(idx === props.phones.length - 1 || props.phones.length === 0) && (
                                    <tbody key="addPhone">
                                        <tr>
                                            <td className="c1">
                                                <span className="float-right" />
                                            </td>
                                            <td className="c2 text-right">
                                                <a onClick={() => props.onAdd()}>
                                                    {getText("AddLabel")}
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                )}
                            </table>
                        </div>
                    ))}
                </table>
            </div>
        </>
    );
}

export { PhonesEdit };
